import { gql } from 'graphql-request'

export const QueryBlockFiltering = gql`
  fragment FragmentBlockFiltering on BlockIntegrationsFilteringModelRecord {
    __typename
    id
    title
    description {
      value
    }
    smallBlock {
      title
      icon
      description {
        value
      }
      action {
        ...FragmentNavigationItem
      }
    }
    categories {
      id
      title
      slug
      bodyTitle
      introCopy {
        value
      }
      bodyCopy {
        value
      }
    }
  }
`

export const BlockIntegrationsFiltering = {
  __typename: 'BlockIntegrationsFiltering',
  fragmentName: 'FragmentBlockFiltering',
  fragmentQuery: QueryBlockFiltering,
  fragments: ['FragmentNavigationItem']
}
